const maintenancesTab = {
  button: 'AGREGAR NUEVO MANTENIMIENTO',
  text: 'SIN MANTENIMIENTO REGISTRADO',
  loadMoreButton: 'CARGAR MÁS',
};

export default maintenancesTab;